export const WEATHER_STATION_TYPES = ['WeatherStation', 'Weather Station'] as const

export const normalizeAssetType = (type: unknown) =>
  typeof type === 'string' ? type.replace(/[\s_-]/g, '').toLowerCase() : ''

const WEATHER_STATION_KEY = normalizeAssetType(WEATHER_STATION_TYPES[0])

export const isWeatherStationType = (type: unknown) =>
  normalizeAssetType(type) === WEATHER_STATION_KEY

export const isWeatherStation = (asset?: { metadata?: unknown } | null) =>
  isWeatherStationType(
    (asset?.metadata as { type?: unknown } | undefined)?.type,
  )
